import { Chip, Skeleton, Typography } from "@mui/material";
import React from "react";
import { safeParseJSON } from "../../utils/safeParseJSON";
import { useUsers } from "../../hooks/useUsers";
import { useCurrentUser } from "../../hooks/useCurrentUser";

type Props = {
  content: string;
  renderMentionAsNormal?: boolean;
};

export function Comment({ content, renderMentionAsNormal = false }: Props) {
  const { users, isLoading } = useUsers();
  const { currentUser } = useCurrentUser();
  const jsonContent = safeParseJSON<{ Content: string; Type: string }[]>(content, []);

  return (
    <>
      {jsonContent.map((part, index) => {
        if (part.Type === "mention") {
          if (isLoading) return <Skeleton key={index} width="40px" sx={{ display: "inline-block" }} />;
          const name = users.find(({ id }) => id === part.Content)?.fullName;
          if (!name) return <React.Fragment key={index} />;
          if (renderMentionAsNormal)
            return (
              <Typography key={index} component="span">
                {name}
              </Typography>
            );
          if (part.Content === currentUser?.id) {
            return (
              <Chip
                key={index}
                label={<Typography>{name}</Typography>}
                color="primary"
                size="small"
                sx={{
                  height: "unset",
                  borderRadius: "4px",
                  "& > .MuiChip-label": { paddingLeft: "4px", paddingRight: "4px" },
                }}
              />
            );
          } else {
            return (
              <Typography key={index} component="span" color="primary">
                {name}
              </Typography>
            );
          }
        } else {
          return (
            <Typography key={index} component="span" whiteSpace="pre-wrap" sx={{ wordBreak: "break-word" }}>
              {part.Content}
            </Typography>
          );
        }
      })}
    </>
  );
}
